import { Box, Flex } from "@chakra-ui/react";
import { COMMON_WEB_PATH } from "../../../constant";
import { useSelector } from "react-redux";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { languageTransfer } from "../../../utils/languageTransfer";
import i18next from "i18next";
import GameItem from "../../../components/GameItem/GameItem";

const TopGameList = () => {
  const handleAllGame = useSelector((state) => state.isHandleAllGame);

  const { topGameList } = handleAllGame;

  const handleDrag = () => {
    const list = document.querySelector(".splide__list");
    list.classList.add("will-change-transform");
  };

  const handleDragged = () => {
    const list = document.querySelector(".splide__list");
    list.classList.remove("will-change-transform");
  };

  return (
    <Flex
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      // mb="10px"
      display={{ base: "flex", sm: "none" }}
      bgImage={`${COMMON_WEB_PATH}/now888/rank/TopGamesBackground.png`}
      bgRepeat={`no-repeat`}
      bgSize={`100% 100%`}
      bgPos="center"
      maxW="100dvw"
      w="100%"
      h="190px"
      pt="57px"
      pb="16px"
      pl="20px"
      pr="40px"
    >
      <Box overflow="hidden" borderRadius={"35px"} w="100%">
        <Splide
          onDrag={handleDrag}
          onDragged={handleDragged}
          className={`h-full w-full`}
          options={{
            type: "slide",
            pagination: false,
            arrows: false,
            // fixedWidth: "80px",
            perPage: 3,
            perMove: 1,
            lazyLoad: "nearby",
            preloadPages: 3,
            fixedHeight: "100%",
            gap: 5,
          }}
        >
          {topGameList?.map((item, index) => {
            const gameName =
              item?.[`gameName${languageTransfer({ lang: i18next.language })}`];
            const gameNameEn = item?.gameNameEn;
            const platform = item?.game_platform;
            const gameSubType = item?.game_subtype;
            const gameCode = item?.gameCode;
            const gameType = item?.gameType;
            return (
              <SplideSlide key={`top-${platform}-${gameNameEn}-${index}`}>
                <GameItem
                  gameProps={{
                    gameName,
                    platform,
                    gameCode,
                    gameType,
                    gameNameEn,
                    gameSubType,
                  }}
                  isHot
                  fullImageLayout
                  itemIndex={index}
                  originProps={item}
                  hiddenTag
                />
              </SplideSlide>
            );
          })}
        </Splide>
      </Box>
    </Flex>
  );
};

export default TopGameList;
